import Plugin from '../plugin';
import ListAction from './list-action';
import FiltersAction from './filters-action';
import LatestAction from './latest-action';
import AdjacentAction from './adjacent-action';

/**
 * Plugin for managing blog posts from the Lawyer API.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class Blog extends Plugin {
  constructor(containers: NodeListOf<HTMLElement>) {
    super(containers);

    this.containers.forEach(container => {
      let actionContainer = container.querySelector('[data-action="list"]') as HTMLElement;
      if (actionContainer) {
        const action = new ListAction(this, actionContainer);
        this.addAction(action);
        this.actionReadyEvent.dispatch(action);
        return;
      }

      actionContainer = container.querySelector('[data-action="filters"]') as HTMLElement;
      if (actionContainer) {
        const action = new FiltersAction(this, actionContainer);
        this.addAction(action);
        this.actionReadyEvent.dispatch(action);
        return;
      }

      actionContainer = container.querySelector('[data-action="latest"]') as HTMLElement;
      if (actionContainer) {
        const action = new LatestAction(this, actionContainer);
        this.addAction(action);
        this.actionReadyEvent.dispatch(action);
        return;
      }

      actionContainer = container.querySelector('[data-action="adjacent"]') as HTMLElement;
      if (actionContainer) {
        const action = new AdjacentAction(this, actionContainer);
        this.addAction(action);
        this.actionReadyEvent.dispatch(action);
        return;
      }
    });

    this.readyEvent.dispatch();
  }
}
